import { shape } from 'prop-types'

import PriceES_v1 from './PriceES_v1'

export default {
  listPrice: shape(PriceES_v1),
  retailPrice: shape(PriceES_v1),
}
